import { render, staticRenderFns } from "./TraxAccountAuthPasswordReset.vue?vue&type=template&id=18fd2b7f"
import script from "./TraxAccountAuthPasswordReset.vue?vue&type=script&lang=js"
export * from "./TraxAccountAuthPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports